import { render, staticRenderFns } from "./SubCalculator.vue?vue&type=template&id=52c52c89&scoped=true"
import script from "./SubCalculator.vue?vue&type=script&lang=js"
export * from "./SubCalculator.vue?vue&type=script&lang=js"
import style0 from "./SubCalculator.vue?vue&type=style&index=0&id=52c52c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c52c89",
  null
  
)

export default component.exports